/** @module searchUtils */
import { SPACE, BACKSPACE, TRASH } from './search.constants';

export const formattingInput = (symbol, input) => {
  const isDoubleSpace = symbol === SPACE && input[input.length - 1] === ' ';
  const isSpaceAtTheBeginning = symbol === SPACE && input.length === 0;

  if (isDoubleSpace || isSpaceAtTheBeginning) {
    return input;
  }

  switch (symbol) {
    case SPACE:
      input += ' ';
      break;
    case BACKSPACE:
      input = input.slice(0, input.length - 1);
      break;
    case TRASH:
      input = '';
      break;
    default:
      input += symbol;
      break;
  }

  return input;
};
